// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner-module--root--2jtce","content":"Banner-module--content--38Tkt","button":"Banner-module--button--rI9Z0","message":"Banner-module--message--2tvkl"};